import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IDeactivateVentureUserAssignmentProps {
  userId: string;
  reason?: string;
}

export const deactivateVentureUserAssignmentService = async ({
  userId,
  reason,
}: IDeactivateVentureUserAssignmentProps): Promise<void> => {
  await jhsfBookingsApi.delete(`/users/${userId}/venture-assignment`, {
    data: { reason: reason || undefined },
  });
};

export default deactivateVentureUserAssignmentService;
